import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Card, Table } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const SHGWiseReportList = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [municipalityList, setMunicipalityList] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [circleList, setcircleList] = useState([]);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    district_id: "",
    subdivision_id: "",
    circle_id: "",
    municipality_id: "",
    school_id: "",
    class_id: "",
  });

  const muniName = localStorage.getItem("name");

  const [loading, setLoading] = useState(false);

  const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });


  const loadReports = async (
  pageNo = 1,
  pageSize = perPage
) => {
  try {
    setLoading(true);

const token = localStorage.getItem("token");

    const payload = {
      page: String(pageNo),
      per_page: String(pageSize),
    };

    const res = await axios.post(
      `${BASE_URL}/municipalitySHGwiseSHGmemberReport`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setReports(res.data.data || []);
    setPage(pageNo);

    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
      Math.ceil((res.data.total_records || 0) / pageSize)
    );
  } catch (err) {
      if (handle401(err)) return;
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  loadReports(1, perPage);
}, []);











  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    borderTopLeftRadius: "10px",
    backgroundColor: "#edf7fe",
    height: "10px",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };

  const getPageNumbers = () => {
    const pages = [];
    const max = 5;

    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + max - 1);

    if (end - start < max - 1) {
      start = Math.max(1, end - max + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };




  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* 🔍 FILTER CARD */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        {/* HEADER */}
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> SHG Wise Member Count Report Filters
          </h5>
        </div>

        {/* FILTER BODY */}
        <Card.Body className="px-4 py-4">
          <Row className="align-items-end">

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Record Showing
                </Form.Label>

                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4} className="d-flex gap-3 mb-3">
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#1565C1",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                onClick={() => {
  loadReports(1, perPage);
}}

              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#E53935",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                onClick={() => {
                  const resetFilters = {
                    district_id: "",
                    subdivision_id: "",
                    circle_id: "",
                    municipality_id: "",
                    school_id: "",
                    class_id: "",
                  };

                  setFilters(resetFilters);
                  setSubDivisionList([]);
                  setSchoolList([]);
                  setcircleList([]);
                  setReports([]);
                  setPage(1);
                  setPerPage(10);
                  setTotalPages(1);
                  setTotalRecords(0);

                  loadReports(1, 10);


                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* {userTypeId === 2 && (
        <div className="text-center mb-4">
          <h4 className="fw-bold text-dark mb-1">{muniName}</h4>
          <div className="fs-6 text-success">
            School-wise Measurement Report (As on {today})
          </div>
        </div>
      )}

      {reports.length > 0 && userTypeId === 1 && filters.municipality_id && (
        <div className="text-center mb-4">
          <h4 className="fw-bold text-dark mb-1">{}</h4>
          <div className="fs-6 text-success">
            School-wise Measurement Report (As on {today})
          </div>
        </div>
      )} */}

      <Card
        className="border-0"
        style={{
          background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          overflow: "hidden",
        }}
      >
        {loading ? (
          <div className="loader-wrapper">
            <div className="blue-spinner"></div>

            <div className="loading-line">
              <div className="loading-progress"></div>
            </div>

            <p className="loading-text">
              Please Wait... While Gathering Reports
            </p>
          </div>
        ) : (
          <>
            <Table bordered hover responsive striped className="mb-0">
  <thead style={{ background: "#edf7fe" }}>
    <tr>
      <th style={theadStyle}>SL No</th>
      <th style={theadStyle}>SHG Name</th>
      <th style={theadStyle}>SHG Members Count</th>
      <th style={theadStyle}>Members</th>
    </tr>
  </thead>

  <tbody>
    {reports.length ? (
      reports.map((r, i) => (
        <tr key={r.shg_id ?? i}>
          {/* SL NO */}
          <td className="text-center">
            {(page - 1) * perPage + i + 1}
          </td>

          {/* SHG NAME */}
          <td className="text-center">{r.shg_name || "-"}</td>

          {/* COUNT */}
          <td className="text-center">
            {r.shg_members_count ?? 0}
          </td>

          {/* MEMBERS LIST */}
          <td>
            {Array.isArray(r.members) && r.members.length > 0 ? (
              r.members.map((m, idx) => (
                <div key={m.user_id ?? idx}>
                  {idx + 1}. {m.name}
                </div>
              ))
            ) : (
              <span>-</span>
            )}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="4" className="text-center text-muted py-4">
          No records found
        </td>
      </tr>
    )}
  </tbody>
</Table>


            {totalPages > 1 && (
              <div className="d-flex justify-content-center my-4">
                <nav>
                  <ul className="pagination shadow-sm">
                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => loadReports(1)}
                      >
                        «
                      </button>
                    </li>

                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => loadReports(page - 1)}
                      >
                        ‹
                      </button>
                    </li>

                    {getPageNumbers().map((p) => (
                      <li
                        key={p}
                        className={`page-item ${page === p ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => loadReports(p, perPage)}
                        >
                          {p}
                        </button>
                      </li>
                    ))}

                    <li
                      className={`page-item ${
                        page === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => loadReports(page + 1)}
                      >
                        ›
                      </button>
                    </li>

                    <li
                      className={`page-item ${
                        page === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => loadReports(totalPages)}
                      >
                        »
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
};

export default SHGWiseReportList;
